<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTitle" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-12">
                            <div class="wrapper">
                                <div class="box">
                                    <v-drop-zone-upload :projectNumber="projectObject.project_number" :projectId="$route.params.project" @onAction="onChangeFile"></v-drop-zone-upload>
                                </div>
                                <div class="box">
                                    <div class="filter filter--media">
                                        <div class="grid-x grid-margin-x">
                                            <div class="cell medium-6 large-7">
                                                <p v-html="$t('internalfiles.description')"></p>
                                                <div class="form-group form-group--check">
                                                    <label class="small"><input type="checkbox" name="select_all" v-model="filesSelectAll" @change="onSelectAllFiles" /> <i></i> {{ $t('select_all' )}}</label>
                                                </div>
                                            </div>
                                            <div class="cell medium-6 large-5">
                                                
                                                <div class="form-group form-group--right">
                                                    
                                                    <template v-if="filesTableItemsCount >= 1">
                                                        <button class="button small u-extra-small-margin--bottom" :class="{ 'disabled': generatingZip }" @click="exportFiles">
                                                        {{ $t('internalfiles.button.export') }}
                                                        </button>
                                                    </template>
                                                    
                                                    <template v-if="zipDownloadFile.name">
                                                    <a
                                                        :download="zipDownloadFile.name"
                                                        :href="zipDownloadFile.url"
                                                        target="_blank"
                                                        class="button small secondary u-extra-small-margin--bottom"
                                                    > {{ $t('internalfiles.button.download') }}</a>
                                                    </template>    
                                                                                                  
                                                    <label for="form-element-sort" class="small">{{ $t('media.selected_files') }}</label>
                                                    <select id="form-element-sort" class="form-control form-control--small form-control--select" v-model="filesAction" @change="onChangeAction">
                                                        <template v-if="$store.getters.userHasPermission('internalfiles_delete')">
                                                            <option value="delete">{{ $t('delete') }}</option>
                                                        </template>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <v-blocks id="media" :isLoading="filesTableLoading" :items="filesTableItems" :useDeactivatedSwitch="false">
                                        <template slot="block" slot-scope="{ row }">
                                            <div class="form-group form-group--check">
                                                <label>
                                                    <input type="checkbox" name="upload[]" :value="row.id" v-model="filesTableItemsSelected[row.id]"> <i></i>
                                                </label>
                                                <div class="media media--block">
                                                    <template v-if="row.type[0] === 'image'">
                                                        <a :href="row.path" target="_blank" class="media--block__thumbnail" :style="'background-image: url(' + row.path + ');'">{{ row.filename }}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a :href="row.path" target="_blank" class="media--block__thumbnail" :class="row.type[1]">{{ row.filename }}</a>
                                                    </template>
                                                    <div class="media--block__content">
                                                        <p class="title"><strong>{{ row.filename }}</strong></p>
                                                        <p>{{ row.comment }}</p>
                                                    </div>
                                                </div>
                                                <button class="button button--action button--action--edit button--small" :title="$t('update')" @click="onUploadObject('update', row)">
                                                    {{ $t('update') }}
                                                </button>
                                            </div>
                                        </template>
                                    </v-blocks>
                                    <v-pagination :currentPage="filesTableCurrentPage" :itemsPerPage="filesTableItemsPerPage" :items="filesTableItemsCount" @pageClicked="onChangeFilesTablePage" />
                                    <v-upload-dialog :projectId="$route.params.project" :method="upload.method" v-model="upload.media" :isVisible="upload.isVisible" @onAction="onChangeFile" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../../partials/PageHeader';
    import PageLoading from '../../partials/PageLoading';
    import Navigation from './../Navigation';

    import Blocks from './../../partials/Foundation/Blocks';
    import Pagination from './../../partials/Foundation/Pagination';
    import UploadDialog from './../../partials/InternalFileDialog';
    
    import DropZoneUpload from '../../partials/DropZoneUpload.vue';

    export default {
        data() {
            return {
                generatingZip: false,
                zipDownloadFile: {},
                loading                     : false,
                loadingError                : null,
                customerObject              : {
                    id                          : 0
                },
                projectObject: {
                    id : 0,
                    project_number: 0
                },
                filesTableLoading         : true,
                filesTableCurrentPage     : 1,
                filesTableItemsPerPage    : 16,
                filesTableItems           : [],
                filesTableItemsCount      : 0,
                filesTableItemsSelected   : {},
                filesAction               : '',
                filesSelectAll            : false,
                upload                      : {
                    isVisible                   : false,
                    method                      : 'create',
                    media                       : {}
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vNavigation             : Navigation,
            vBlocks                 : Blocks,
            vPagination             : Pagination,
            vUploadDialog           : UploadDialog,
            vDropZoneUpload         : DropZoneUpload,
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            getPageTitle : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('project.media.title');
            },
        },
        created : function () {
            this.getProject();
            this.getCustomer();
        },
        methods : {
            exportFiles: function() {
                this.loadingError = null;
                this.generatingZip = true;
                this.zipDownloadFile = {};
                let promise = this.$api.clearParams()
                .addParam('project_id', this.$route.params.project)
                .addParam('project_number', this.projectObject.project_number)
                .get('internalfiles/zipfiles');
                 promise.then((response => {
                        this.zipDownloadFile = response.data.data;
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.generatingZip = false;
                    }).bind(this));              
            }, 
            getProject : function () {
                this.loadingError = null;
                
                if (this.$route.params.project) {
                    let promise = this.$api.clearParams()
                        .get('projects/' + this.$route.params.project + '/get');

                    promise.then((response => {
                        this.projectObject = response.data.data;
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            
            getCustomer : function() {
                this.loadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdateFilesTableItems();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdateFilesTableItems();
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onChangeFilesTablePage : function (page) {
                this.filesTableCurrentPage = page;

                this.onUpdateFilesTableItems();
            },
            onUpdateFilesTableItems : function () {
                let promise = this.$api.clearParams()
                    .setPageParams(this.filesTableCurrentPage, this.filesTableItemsPerPage)
                    .addParam('project_id', this.$route.params.project)
                    .get('internalfiles');

                promise.then((response => {
                    this.filesTableItems          = response.data.data;
                    this.filesTableItemsCount     = response.data.meta.pagination.total;

                    this.filesTableItems.forEach((function (upload, index) {
                        upload.type = upload.file_type.split('/');
                        upload.path = process.env.VUE_APP_MEDIA_URL + upload.path.replace(/^\/|\/$/g, '');
                    }).bind(this));

                    this.filesTableLoading        = false;
                }).bind(this)).catch((error => {
                    this.filesTableLoading        = false;
                }).bind(this));

                this.filesTableLoading = true;
            },
            onChangeFile : function (action, method) {
                switch (action) {
                    case 'upload':
                        this.onChangeFilesTablePage(1);

                        break;
                }

                this.upload = {
                    isVisible   : false,
                    method      : 'create',
                    media       : {}
                };
            },
            onChangeAction : function (event) {
                switch (event.currentTarget.value) {
                    case 'delete':
                        this.onDeleteSelectedMedia();

                        break;
                }
            },
            onDeleteSelectedMedia : function () {
                var selected = this.getSelectedMedia();

                if (selected.length >= 1) {
                    let promise = this.$api.clearParams()
                        .post('internalfiles/delete', {
                            files : selected
                        });

                    promise.then((response => {
                        this.onResetUploadsFilter();
                        this.onUpdateFilesTableItems(1);
                    }).bind(this)).catch((error => {
                        console.log(error);
                    }).bind(this));

                    this.filesTableLoading = true;
                } else {
                    this.onResetUploadsFilter();
                    this.onChangeFilesTablePage(1);
                }
            },
            onSelectAllFiles : function (event) {
                var selected = {};

                this.filesTableItems.forEach((function (upload) {
                    if (event.currentTarget.checked) {
                        selected[upload.id] = true;
                    }
                }).bind(this));

                this.filesTableItemsSelected = selected;
            },
            getSelectedMedia : function () {
                var selected = [];

                for (var key in this.filesTableItemsSelected) {
                    if (this.filesTableItemsSelected[key] === true) {
                        selected.push(parseInt(key));
                    }
                }

                return selected;
            },
            onResetUploadsFilter : function () {
                this.filesAction              = '';
                this.filesSelectAll           = false;
                this.filesTableItemsSelected  = {};
            },
             onClickAction : function (action) {
                switch (action) {
                    case 'upload':
                        this.onUploadObject('create');

                        break;
                }
            },
            onUploadObject : function (method, media) {
                if (media) {
                    media = {
                        id          : media.id,
                        project_id  : media.project_id,
                        file        : {
                            name        : media.filename
                        },
                        comment     : media.comment
                    };
                }

                this.upload = {
                    isVisible   : true,
                    method      : method,
                    media       : media || {}
                };
            },

        }
    }
</script>